import { SkeletonItem } from '@capsicum/common-web';
import styled from 'styled-components';

export const CredentialGuardLoader = ({ testID }: { testID?: string }) => (
	<S.Splash data-testid={testID || 'credential-guard-loader'}>
		<S.RoundWrapper>
			<SkeletonItem circle height="100%" width="100%" />
		</S.RoundWrapper>
	</S.Splash>
);

namespace S {
	export const Splash = styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100vw;
		height: 100vh;
	`;

	export const RoundWrapper = styled.div`
		width: 100px;
		height: 100px;
		border-radius: 50%;
	`;
}
